export default __webpack_public_path__ + "assets/ogg/46f9ef45150f283e8b03607aef35a26a.ogg";